import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import JsonTreeModal from './JsonTreeModal';

export const parseJsonValue = (value) => {
  if (value == null) return null;
  if (typeof value === 'object') return value;
  if (typeof value === 'string' && value !== '') {
    try {
      return JSON.parse(value);
    } catch {
      return value;
    }
  }
  return value;
};

const summarizeJsonValue = (parsed) => {
  if (parsed == null || parsed === '') return null;
  if (typeof parsed === 'object') {
    if (Array.isArray(parsed)) {
      return `${parsed.length} item${parsed.length === 1 ? '' : 's'}`;
    }
    const keys = Object.keys(parsed);
    return `${keys.length} field${keys.length === 1 ? '' : 's'}`;
  }
  const text = String(parsed);
  return text.length > 100 ? `${text.slice(0, 100)}…` : text;
};

const CollapsibleJsonDetail = ({ label, value }) => {
  const [showModal, setShowModal] = useState(false);
  const parsed = parseJsonValue(value);

  if (parsed == null || parsed === '') {
    return null;
  }

  const summary = summarizeJsonValue(parsed);
  const modalTitle = label || 'JSON detail';

  return (
    <>
      <div className="task-detail__json-fold">
        <div className="d-flex flex-wrap align-items-center gap-2">
          {label && <span className="text-muted fw-semibold small">{label}</span>}
          <Button
            variant="outline-secondary"
            size="sm"
            onClick={() => setShowModal(true)}
          >
            View detail
          </Button>
          {summary && (
            <span className="text-muted small task-detail__text-break">{summary}</span>
          )}
        </div>
      </div>
      <JsonTreeModal
        show={showModal}
        onHide={() => setShowModal(false)}
        title={modalTitle}
        data={parsed}
      />
    </>
  );
};

export default CollapsibleJsonDetail;
